export default __webpack_public_path__ + "static/media/Belt of the Putrescent.a953c980.jpg";